import React from "react";
import Slider from "react-slick";
import '../../App.css';
import './Carousel.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import p1 from "../../static/img/p1.jpg";
import p2 from "../../static/img/p2.jpg";
import p3 from "../../static/img/p3.jpg";
import p4 from "../../static/img/p4.jpg";
import p5 from "../../static/img/p5.jpg";

const images = [p1, p2, p3, p4, p5];

const settings = {
  dots: false,  // Убираем точки навигации
  arrows: false, // Убираем кнопки навигации
  infinite: true,
  speed: 2000, // Плавное исчезновение и появление
  fade: true, // Эффект плавного перехода
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000, // Интервал между сменами слайдов
};

const CarouselSection = () => {
  return (
    <section className="carousel-section">
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="cntr_carousel_img">
            <img
              src={image}
              alt={`Фото ${index + 1}`}
              className="carousel_img"
            />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default CarouselSection;